import { FirebaseConfig } from './app-config.service';

export type Environment = 'local' | 'dev' | 'int' | 'prod';

export interface AppConfig {
  appVersion: string;
  mediaApiUrl: string;
  fileApiUrl: string;
  uploadUrlLambda: string;
  imageApiUrl: string;
  environment: Environment;
  firebase: FirebaseConfig;
  googleAnalyticsId: string;
  helperUrl: string;
}
